import { AssetQualityLevel, IResourcesGroupConfig } from '@nolimitcity/slot-game/bin/asset/Asset';
import { BitmapFontAsset } from '@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset';
import { SpineAsset } from '@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset';
import { TextureAsset } from '@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset';

export class GameAssets {
    public static BITMAP_FONT_WIN_COUNT_UP_LOW: string = 'NumbersWinCountUp';
    public static BITMAP_FONT_OPENSANS_800 = 'NumbersOpenSans800';
    public static BITMAP_FONT_WIN_COUNT_UP = 'NumbersWinCountUp';
    public static BITMAP_FONT_NORMAL_WIN_COUNT_UP = 'NumbersNormalWinCountUp';
    public static BITMAP_FONT_BIG_WIN_COUNT_UP = 'BigWinCountUp';
    public static MAIN_GAME_BACKGROUND: string = 'mainBackground';
    public static FS_BACKGROUND: string = 'freespinBackground';

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: 'fonts',
                assets: [
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_OPENSANS_800, 'fonts/bitmapfonts/NumbersOpenSans800.fnt'),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_WIN_COUNT_UP, 'fonts/bitmapfonts/NumbersWinCountUp.fnt'),
                    new BitmapFontAsset(
                        GameAssets.BITMAP_FONT_NORMAL_WIN_COUNT_UP,
                        'fonts/bitmapfonts/NumbersNormalWinCountUp.fnt'
                    ),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_BIG_WIN_COUNT_UP, 'fonts/bitmapfonts/BigWinCountUp.fnt'),
                ],
            },
            {
                name: 'backgrounds',
                assets: [new TextureAsset('backgroundsJpeg0', 'sheets/backgroundsJpeg/backgroundsJpeg0.json')],
                animations: {
                    mainBackground: 'maingameBackground',
                },
            },
            {
                name: 'spine',
                assets: [

                    new SpineAsset('rope_cut', 'spine/rope_cut.json'),


                    new SpineAsset('cauldronFire', 'spine/couldron.json'),
                    new SpineAsset('spine/loading_bar.json', 'spine/loading_bar.json'),

                    new SpineAsset('independent_lock', 'spine/indicator_lock_separate.json'),
                    new SpineAsset('independent_ring', 'spine/indicator_ring_separate.json'),

                    new SpineAsset('SW_Green', 'spine/indicator_green.json'),
                    new SpineAsset('SW_Purple', 'spine/indicator_purple.json'),
                    new SpineAsset('SW_Red', 'spine/indicator_red.json'),
                    new SpineAsset('soul_wild_green', 'spine/soul_wild_green.json'),
                    new SpineAsset('soul_wild_purple', 'spine/soul_wild_purple.json'),
                    new SpineAsset('soul_wild_red', 'spine/soul_wild_red.json'),
                    new SpineAsset('backgroundAnim', 'spine/bg_levels.json'),
                    new SpineAsset('backgroundTopAnim', 'spine/bg_top_level.json'),
                    new SpineAsset('couldronBack', 'spine/couldron_back.json'),
                    new SpineAsset('couldronTop', 'spine/couldron_top.json'),

                    new SpineAsset('sfsIntro', 'spine/SFS_intro.json'),
                    new SpineAsset('W', 'spine/W.json'),
                    new SpineAsset('Scatter', 'spine/S.json'),
                    new SpineAsset('L1', 'spine/L1.json'),
                    new SpineAsset('L2', 'spine/L2.json'),
                    new SpineAsset('L3', 'spine/L3.json'),
                    new SpineAsset('L4', 'spine/L4.json'),
                    new SpineAsset('L5', 'spine/L5.json'),
                    new SpineAsset('M_H1', 'spine/M1.json'),
                    new SpineAsset('M_H2', 'spine/M2.json'),
                    new SpineAsset('M_H3', 'spine/M3.json'),
                    new SpineAsset('M_H4', 'spine/M4.json'),
                    new SpineAsset('M_H5', 'spine/M5.json'),
                    new SpineAsset('BW0', 'spine/BW_L1.json'),
                    new SpineAsset('BW1', 'spine/BW_L2.json'),
                    new SpineAsset('BW2', 'spine/BW_L3.json'),
                    new SpineAsset('BW3', 'spine/BW_L4.json'),
                    new SpineAsset('BW4', 'spine/BW_L5.json'),
                    new SpineAsset('bigWin', 'spine/bigwins.json'),
                    new SpineAsset('spine/sw_bar.json', 'spine/sw_bar.json'),
                    new SpineAsset('swirl_zone', 'spine/SW_zone.json'),
                    new SpineAsset('spine/W_piece_spawn.json', 'spine/W_piece_spawn.json'),
                    new SpineAsset('spine/soul.json', 'spine/soul.json'),
                    new SpineAsset('character', 'spine/end_presentation_character.json'),
                    new SpineAsset('option1', 'spine/blue_jar.json'),
                    new SpineAsset('option2', 'spine/red_jar.json'),
                    new SpineAsset('endAnimation', 'spine/end_presentation_fx.json'),
                    new SpineAsset('cauldronSym', 'spine/lvlup_bar.json'),
                    new SpineAsset('spine/lvlup_bar.json', 'spine/lvlup_bar.json'),
                    new SpineAsset('spine/lvlup_guy.json', 'spine/lvlup_guy.json'),
                    new SpineAsset('spine/couldron_middle.json', 'spine/couldron_middle.json'),
                    new SpineAsset('spine/rope_burn.json', 'spine/rope_burn.json'),
                    new SpineAsset('spine/tree_glow.json', 'spine/tree_glow.json'),
                    new SpineAsset('spine/indicator_ring.json', 'spine/indicator_ring.json'),


                    new SpineAsset('wincap', 'spine/wincap.json'),

                    new SpineAsset('BigWin_Tranition', 'spine/transition effects.json'),

                    new SpineAsset('generalMultiplier', 'spine/multiplier.json'),
                ],
            },
            {
                name: 'main',
                assets: [
                    new TextureAsset('main0', 'sheets/main/main0.json'),
                    new TextureAsset('main1', 'sheets/main/main1.json'),
                    new TextureAsset('main2', 'sheets/main/main2.json'),
                    new TextureAsset('main3', 'sheets/main/main3.json'),
                    new TextureAsset('main4', 'sheets/main/main4.json'),
                    new TextureAsset('main5', 'sheets/main/main5.json'),
                    new TextureAsset('main6', 'sheets/main/main6.json'),
                    new TextureAsset('main7', 'sheets/main/main7.json'),
                ],
                animations: {
                    mainBgOverlay: 'backgroundAssets/mainBgAsset',
                    mainBgTop: 'backgroundAssets/topBgbark',
                    phantom1: 'phantom_01',
                    phantom2: 'phantom_02',
                    phantom3: 'phantom_03',
                    maxWin: 'maxWin/maxWin',
                    maxWinMultiplier: 'maxWin/maxWinAmount',
                    logo: 'logo/logo',
                    hSymbolFrame: 'loading_bar_symbol/hSymbolBase',
                    h1: 'loading_bar_symbol/h1',
                    h2: 'loading_bar_symbol/h2',
                    h3: 'loading_bar_symbol/h3',
                    h4: 'loading_bar_symbol/h4',
                    h5: 'loading_bar_symbol/h5',
                    title: 'choose_a_potion/chooseTitle',
                    sfsSpinText: 'SFS/tzantzaSpins',
                    soul_glowout: "soul_glowout/soul_glowout_",
                    trail_effect: "trail_effect/trail_effect/trail_effect_",
                    
                },
            },
            {
                name: 'mainJpeg',
                assets: [
                    new TextureAsset('mainJpeg0', 'sheets/mainJpeg/mainJpeg0.json'),
                    new TextureAsset('mainJpeg1', 'sheets/mainJpeg/mainJpeg1.json'),
                    new TextureAsset('mainJpeg2', 'sheets/mainJpeg/mainJpeg2.json'),
                    new TextureAsset('mainJpeg3', 'sheets/mainJpeg/mainJpeg3.json'),
                    new TextureAsset('mainJpeg4', 'sheets/mainJpeg/mainJpeg4.json'),
                    new TextureAsset('mainJpeg5', 'sheets/mainJpeg/mainJpeg5.json'),
                    new TextureAsset('mainJpeg6', 'sheets/mainJpeg/mainJpeg6.json'),
                    new TextureAsset('mainJpeg7', 'sheets/mainJpeg/mainJpeg7.json'),
                    new TextureAsset('mainJpeg8', 'sheets/mainJpeg/mainJpeg8.json'),
                    new TextureAsset('mainJpeg9', 'sheets/mainJpeg/mainJpeg9.json'),
                    new TextureAsset('mainJpeg10', 'sheets/mainJpeg/mainJpeg10.json')
                ],
                animations: {
                    bg_smoke_1: 'smoke1/smoke1_',
                    bg_smoke_2: 'smoke2/smoke2_',
                    swosh: 'swosh/swosh_',
                    indicator_swosh: 'indicator_swosh/indicator_swosh_',
                    cauld_fire: 'big_win_effect/beheaded/fire_particals/fire_particals_',
                    blueCouldronSplash: 'blue_splash/blue_splash/blue_splash_',
                    blueSplashBall: 'blue_splash/splash_ball/splash_ball_',
                    blueMultiplier_blast: 'blue_splash/multiplier_blast/multiplier_blast_',
                    lightning1: 'lightning/lightning_1/lightning_1_',
                    lightning2: 'lightning/lightning_2/lightning_2_',
                    lightning3: 'lightning/lightning_3/lightning_3_',
                    ghostFlame: "ghost_flame/ghost_flame_",
                    bg_sparks: "bg_sparks/bg_sparks_",
                    smoke_puff_2: "smoke_puff_2/smoke_puff2_",
                    
                },
            },
            {
                name: 'symbols',
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [new TextureAsset('symbols0', 'sheets/symbols/symbols0.json')],
            },
        ],
    };
}
